export function formatBayPlatformLabel(bay: string | null | undefined, platformCode: string | null | undefined): string | null {
    const normalizedBay = normalizeValue(bay);
    if (normalizedBay) {
        if (/^bay\b/i.test(normalizedBay)) {
            return normalizedBay;
        }

        return `Bay ${normalizedBay}`;
    }

    const normalizedPlatform = normalizeValue(platformCode);
    if (!normalizedPlatform) {
        return null;
    }

    if (/^platform\b/i.test(normalizedPlatform)) {
        return normalizedPlatform;
    }

    return `Platform ${normalizedPlatform}`;
}

function normalizeValue(value: string | null | undefined): string | null {
    if (!value) {
        return null;
    }

    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
}
